// @ts-check
/**
 * @module planejamento/models
 */

export class Meta {

	constructor( metaOrTema = {} ) {
		if ( metaOrTema == null ) {
			metaOrTema = {};
		}
		/**
		 * @type {number|null}
		 */
		this.tema = toIntegerOrNull( metaOrTema.tema ) || toIntegerOrNull( metaOrTema );
		/**
		 * @type {number|null}
		 */
		this.id = toIntegerOrNull( metaOrTema.id );
		/**
		 * @type {boolean|null}
		 */
		this.usaBncc = toBoolean( metaOrTema.usaBncc );
	}
}

export class Tema {

	/**
	 * @param tema {any}
	 */
	constructor( tema = null ) {
		if ( tema == null || typeof tema !== 'object' ) {
			tema = {
				codigo: tema
			}
		}

		/**
		 * @type {number|null}
		 */
		this.codigo = toIntegerOrNull( tema.codigo );
		/**
		 * @type {string}
		 */
		this.descricao = tema.descricao || null;
		/**
		 * @type {number|null}
		 */
		this.ordem = toIntegerOrNull( tema.ordem );
	}
}

/**
 *
 * @param {any} val
 * @returns {number|null}
 */
export function toIntegerOrNull( val ) {
	if ( /^-?[0-9]+$/.test( val ) ) {
		return +val;
	} else {
		return null;
	}
}

/**
 *
 * @param {any} val
 * @returns {boolean}
 */
export function toBoolean( val ) {
	return /^true$/.test( val );
}
